import { render, staticRenderFns } from "./SectionFooter.vue?vue&type=template&id=148dd11c&"
import script from "./SectionFooter.vue?vue&type=script&lang=js&"
export * from "./SectionFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports